import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics, useFitmentCheck } from '@app/hooks';
import {
  LIST_PCC_EDIT_QUOTE,
  LIST_PCC_CART_PAGE
} from '@app/constants/analyticsConstants';
import { getGACheckoutProducts } from '@app/hooks/useAnalytics/utils';
import { convertFormattedNumberToUnformatted } from '../../../utils';

const useGACartEvents = () => {
  const { fireAddToCartEvent, fireBeginCheckoutEvent } = useAnalytics();
  const { getFitmentCheck } = useFitmentCheck();
  const current = useSelector(s => s.orders.current);
  const originalQuoteNumber = useSelector(
    s => s.orders?.byId?.[current]?.orderExtendAttribute?.originalQuoteNumber
  );
  const listName = originalQuoteNumber
    ? LIST_PCC_EDIT_QUOTE
    : LIST_PCC_CART_PAGE;
  const emailCart = useSelector(s => s.common.emailCart);
  const relatedModel = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );
  const currentOrder = useSelector(s => s.orders.byId?.[current]);
  const orderTotals = useSelector(s => currentOrder?.orderTotals) ?? {};
  const orderTotal =
    convertFormattedNumberToUnformatted(orderTotals?.orderSubTotal || '') ||
    orderTotals?.unformattedOrderSubTotal;
  const dealerStoreCommon = useSelector(s => s.common?.storeLocationName);

  const dealerStore =
    useSelector(
      s => s.orders?.byId?.[current]?.orderExtendAttribute?.dealerStore
    ) || dealerStoreCommon;

  const fireGAEventFunction = useCallback(
    (orderItems, isCheckout = false, addToCartQuickOrder = false, page) => {
      const gaItems = getGACheckoutProducts({
        products: orderItems.map(p => ({
          ...p,
          orderItemExtendAttribute: {
            ...p.orderItemExtendAttribute,
            googleAnalyticsAttributes: {
              ...p.orderItemExtendAttribute.googleAnalyticsAttributes,
              checkFitment: getFitmentCheck(p.partNumber),
              relatedModel
            }
          }
        })),
        emailCart
      });
      if (isCheckout) {
        fireBeginCheckoutEvent({
          products: gaItems,
          orderTotal,
          dealerStore
        });
      } else {
        const list = page ?? listName;
        fireAddToCartEvent({
          products: gaItems.map(p =>
            addToCartQuickOrder ? { ...p } : { ...p, list }
          ),
          dealerStore
        });
      }
    },
    [fireBeginCheckoutEvent, fireAddToCartEvent, orderTotal]
  );

  return { fireGAEventFunction };
};

export default useGACartEvents;
